import { Button, Dropdown, Modal } from "antd";
import React, { useState } from "react";
import { GoPlusCircle } from "react-icons/go";
import { IoDocumentTextOutline } from "react-icons/io5";
import { LiaTrainSolid } from "react-icons/lia";
import { MdOutlineCalculate } from "react-icons/md";
import { PiHamburger } from "react-icons/pi";
import { Link } from "react-router-dom";
import AddVagon from "./vagon/AddVagon";

export default function KochaHeader({ title = "Yukxatlari" }) {
  let [open, setOpen] = useState(false);
  const items = [
    {
      key: "1",
      label: (
        <Link
          className=" block w-[100%] flex items-center justify-start gap-1"
          rel="noopener noreferrer"
          to="/kocha"
        >
          <IoDocumentTextOutline className="font-[30px]" /> Yuk xatlari
        </Link>
      ),
    },
    {
      key: "2",
      label: (
        <Link
          className=" block w-[100%] flex items-center justify-start gap-1"
          rel="noopener noreferrer"
          to="/kocha/vagonlar"
        >
          <LiaTrainSolid className="font-[30px]" /> Vagonlar
        </Link>
      ),
    },
    {
      key: "3",
      label: (
        <div
          className=" block w-[100%] flex items-center justify-start gap-1"
          rel="noopener noreferrer"
          // to="/kocha/vagonlar/new"
          onClick={() => {
            setOpen(true);
          }}
        >
          <GoPlusCircle className="font-[30px]" /> Vagon
        </div>
      ),
    },
    // {
    //   key: "6",
    //   label: (
    //     <Link
    //       className=" block w-[100%] flex items-center justify-start gap-1"
    //       rel="noopener noreferrer"
    //       to="/"
    //     >
    //       <MdOutlineCalculate className="font-[30px]" /> Jami
    //     </Link>
    //   ),
    // },
  ];
  return (
    <div className="max-w-[900px] m-auto w-[100%] flex  bg-[#fff] z-10 flex-row  items-center justify-between p-[10px]">
      <h2 className="bold text-[20px]">{title}</h2>

      <div className="flex gap-1">
        <Dropdown
          menu={{
            items,
          }}
          placement="topRight"
          arrow
        >
          <Button>
            <PiHamburger />
          </Button>
        </Dropdown>
        <Modal
          style={{ top: "40px", width: "900px" }}
          title="Yangi Vagon"
          open={open}
          width={800}
          //   loading={loadVagon}
          onOk={() => {
            setOpen(false);
          }}
          onCancel={() => {
            console.log("Modal closed via Cancel button or close icon.");
            setOpen(false);
          }}
          footer={[]}
        >
          <AddVagon setOpen={setOpen} />
        </Modal>
      </div>
    </div>
  );
}
